import React from 'react';
import { 
  QrCode as QrCodeIcon,
  DataObject as DataObjectIcon,
  Schedule as ScheduleIcon,
  AccessTime as AccessTimeIcon,
  Tag as TagIcon,
  Lock as LockIcon,
  VpnKey as VpnKeyIcon,
  Key as KeyIcon,
  Storage as StorageIcon,
  Code as CodeIcon,
  Security as SecurityIcon
} from '@mui/icons-material';

import ToolAppLayout from '../../layouts/ToolAppLayout';

import TimestampConverter from './TimestampConverter';
import UUIDGenerator from './UUIDGenerator';
import HashGenerator from './HashGenerator';
import JWTDecoder from './JWTDecoder';
import JWTGenerator from './JWTGenerator';
import MongoIdConverter from './MongoIdConverter';
import RegexTester from './RegexTester';
import QRCodeGenerator from './QRCodeGenerator';
import CronBuilder from './CronBuilder';
import MockDataGenerator from './MockDataGenerator';
import HMACGenerator from './HMACGenerator';

const toolCategories = [
  {
    name: 'Tokens & Security',
    tools: [
      { name: 'JWT Generator', description: 'Create and sign JSON Web Tokens', path: 'jwt-generator', icon: <VpnKeyIcon fontSize="small" />, component: JWTGenerator },
      { name: 'JWT Decoder', description: 'Decode and inspect JWT payloads securely', path: 'jwt-decoder', icon: <KeyIcon fontSize="small" />, component: JWTDecoder },
      { name: 'Hash Generator', description: 'Generate MD5, SHA-1, SHA-256 hashes', path: 'hash-generator', icon: <LockIcon fontSize="small" />, component: HashGenerator },
      { name: 'HMAC Generator', description: 'Generate keyed-hash message authentication codes', path: 'hmac-generator', icon: <SecurityIcon fontSize="small" />, component: HMACGenerator },
    ]
  },
  {
    name: 'Data & Randomness',
    tools: [
      { name: 'UUID Generator', description: 'Generate standard random UUID v4 strings', path: 'uuid-generator', icon: <TagIcon fontSize="small" />, component: UUIDGenerator },
      { name: 'Mock Data', description: 'Generate random mock data structures', path: 'mock-data', icon: <DataObjectIcon fontSize="small" />, component: MockDataGenerator },
    ]
  },
  {
    name: 'Time & Scheduling',
    tools: [
      { name: 'Cron Builder', description: 'Build and parse cron schedule expressions', path: 'cron-builder', icon: <ScheduleIcon fontSize="small" />, component: CronBuilder },
      { name: 'Timestamp Converter', description: 'Convert Unix epochs to human readable dates', path: 'timestamp-converter', icon: <AccessTimeIcon fontSize="small" />, component: TimestampConverter },
    ]
  },
  {
    name: 'Other Utilities',
    tools: [
      { name: 'QR Code', description: 'Generate QR codes from text or URLs', path: 'qr-code', icon: <QrCodeIcon fontSize="small" />, component: QRCodeGenerator },
      { name: 'MongoDB ID', description: 'Extract timestamps from MongoDB ObjectIDs', path: 'mongo-id', icon: <StorageIcon fontSize="small" />, component: MongoIdConverter },
      { name: 'Regex Tester', description: 'Test and debug regular expressions', path: 'regex-tester', icon: <CodeIcon fontSize="small" />, component: RegexTester },
    ]
  }
];

function DevToolsApp() {
  return (
    <ToolAppLayout
      title="Developer Tools"
      description="Essential utilities for generating, decoding, and testing developer data."
      toolCategories={toolCategories}
      basePath="/dev-tools"
    />
  );
}

export default DevToolsApp;
